import { datatable } from "./app"
import { globalSearchObject } from "./searchObjects";

var counter = 0
export function getAllFiltered(){
    try{
        
        counter = counter + 1;
        if(counter == globalSearchObject.allSearchObjects.length){
            datatable.ajax.reload();
            counter = 0
        }
    }
    catch(e){
        console.log(e)
    }
}